import React, { useRef, useState, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { searchTagsForFilter } from '../../services/tags.service';

const TagFilterAutocomplete = ({ value, onChange }) => {
    const intl = useIntl();
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const debounceRef = useRef(null);
    const stableValue = useMemo(() => value ?? [], [value]);

    const handleInputChange = (_, inputValue) => {
        setSearch(inputValue);

        if (debounceRef.current) clearTimeout(debounceRef.current);

        if (!inputValue || inputValue.length < 3) {
            setOptions([]);
            return;
        }

        debounceRef.current = setTimeout(async () => {
            setLoading(true);
            try {
                const res = await searchTagsForFilter(inputValue);
                if (res?.data?.success) {
                    setOptions(res.data.data || []);
                }
            } catch (_) {
                // silently ignore
            } finally {
                setLoading(false);
            }
        }, 800);
    };

    return (
        <Autocomplete
            multiple
            options={options}
            value={stableValue}
            inputValue={search}
            onChange={(_, newValue) => onChange(newValue)}
            onInputChange={handleInputChange}
            getOptionLabel={(option) => option.name || ''}
            isOptionEqualToValue={(option, val) => option.id === val.id}
            filterOptions={(x) => x}
            loading={loading}
            noOptionsText={
                search.length < 3
                    ? 'Digite pelo menos 3 caracteres'
                    : loading
                        ? 'Carregando...'
                        : 'Nenhuma tag encontrada'
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={intl.formatMessage({ id: 'tags' })}
                    placeholder={intl.formatMessage({ id: 'called.filter.tags.placeholder' })}
                    style={{ background: 'white' }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
};

export default TagFilterAutocomplete;
